import React from "react";
import { withTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import PropTypes from "prop-types";
//i18n

import InputFieldText from "Components/Common/InputFieldText";
import SelectField from "Components/Common/SelectField";

import { convertCamelTextToCapitalizeText } from "utils/convertCamelTextToCapitalizeText";

const options = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];

const DeclarationField = ({ item, formik, t }) => {
  const { setFieldValue, values, setFieldTouched } = formik;

  const onChangeHandler = (option) => {
    if (!option.value) {
      setFieldTouched(`declaration.${item.name}`, false);
      setFieldValue(`declaration.${item.name}`, "");
    }
    setFieldValue(`declaration.${item.selectFieldName}`, option.value);
  };

  return (
    <React.Fragment key={item.name}>
      <Row>
        <Col className="declarations-font-size d-flex gap-2 mb-2" md={8}>
          <span>{t(item?.description)}</span>
        </Col>

        <Col md={4}>
          <SelectField
            label={convertCamelTextToCapitalizeText(item.name)}
            name={`declaration.${item.selectFieldName}`}
            options={options}
            formik={formik}
            onChange={(_, option) => onChangeHandler(option)}
            value={
              options.find(
                ({ value }) =>
                  value === values.declaration[item.selectFieldName]
              ) ?? ""
            }
          />
        </Col>
      </Row>
      <Row>
        <Col md={8}></Col>
        {values.declaration[item.selectFieldName] && (
          <Col md={4}>
            <InputFieldText
              label={t(item.placeholder) + "*"}
              name={`declaration.${item.name}`}
              formik={formik}
              placeholder={t("Enter Consumer Number")}
            />
          </Col>
        )}
      </Row>
    </React.Fragment>
  );
};

DeclarationField.propTypes = {
  item: PropTypes.object,
  formik: PropTypes.object,
  t: PropTypes.func,
};

export default withTranslation()(DeclarationField);
